/**
 * Hook: passthrough. Page-wide translation is now handled by the global DOM
 * engine (lib/autoTranslate.js), so per-string translation here would double up.
 */
export function useTranslatedText(src) {
    return src || "";
}

/**
 * Auto-translates user-generated content to the active UI language.
 * When the language is English (or text is empty) it renders as-is.
 * Otherwise it fetches an LLM translation and swaps it in when ready.
 */
export default function TranslatedText({ text, children, as: Tag = "span", className, ...rest }) {
    const src = (text ?? (typeof children === "string" ? children : "")) || "";
    const out = useTranslatedText(src);
    return <Tag className={className} {...rest}>{out}</Tag>;
}
